import React from 'react'
import styled from 'styled-components'

const EnergyForecastContainer = styled.div`
    display: flex;
    flex-direction: row;
    `

const DemandForecast = () => {
  return (
    <EnergyForecastContainer>
      DemandForecast
    </EnergyForecastContainer>
  )
}

export default DemandForecast
